const PERFORMANCE_SET = 'PERFORMANCE_SET';
const PERFORMANCE_BENCHMARK_OPTIONS_SET = 'PERFORMANCE_BENCHMARK_OPTIONS_SET';
const PERFORMANCE_BENCHMARK_OPTIONS_UPDATED = 'PERFORMANCE_BENCHMARK_OPTIONS_UPDATED';

export  {
    PERFORMANCE_SET,
    PERFORMANCE_BENCHMARK_OPTIONS_SET,
    PERFORMANCE_BENCHMARK_OPTIONS_UPDATED,
}
